import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { WorkOrderReadDTO } from './dto';
import { GetManyPaged } from './types';

export const WORK_ORDERS_PATH = 'work-orders';

export const getWorkOrders: GetManyPaged<WorkOrderReadDTO> = async ({ filter, page, size, sort, config } = {}) =>
    client
        .get(buildPath([WORK_ORDERS_PATH]), { ...config, params: { filter, page, size, sort } })
        .then((response: AxiosResponse) => response.data);
